import React from 'react';
import styled from 'styled-components';
import HomeHeroBgImage from '../../assets/general/home-hero-bg.jpeg';
import Button from '../Button';
import IntelliCubixColoredImage from '../../assets/general/intellicubix-colored.png';
import HomeHeroImage from '../../assets/general/home-hero-image.png';

const MainContainer = styled.div`
  width: 100%;
  background-image: url(${HomeHeroBgImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 20px 0;
`;

const Overlay = styled.div`
  width: 100%;
  max-width: 1170px;
  margin: 0 auto;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 20px;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const HeroLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
`;

const HeroRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    align-items: center;
    width: 100%;
    justify-content: center;
  }
`;

const TitleContainer = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.orange};
  font-family: ${(props) => props.theme.fonts.headline};
  text-shadow: 1px 1px 3px rgba(0, 0, 0, .5);
  line-height: 1.3;
  margin-bottom: 30px;
  letter-spacing: 2px;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    margin: 0 auto 20px auto;
  }
`;

const IntelliCubixColored = styled.img`
  width: 301px;
  height: 50px;
  margin-bottom: 10px;
`;

const HeroDescription = styled.p`
  font-size: 22px;
  font-weight: 300;
  color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fonts.content};
  text-shadow: 1px 1px 3px rgba(0, 0, 0, .5);
  text-align: justify;
`;

const HomeHeroImg = styled.img`
  width: 500px;
  height: 500px;
  object-fit: cover;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    display: none;
  }
`;

const HomeHeroSection = () => {
  return <MainContainer>
    <Overlay>
      <HeroLeft>
        <TitleContainer>Digital Solutions for Your Business</TitleContainer>
        <IntelliCubixColored src={IntelliCubixColoredImage} alt="Intellicubix Colored" />
        <HeroDescription>Your compass in the world of innovation. From idea to execution, we're your ultimate partner in strategy, design, and development. Let's transcend the ordinary, sculpting digital masterpieces with precision and flair. Join us, and let's redefine the future together!</HeroDescription>
        <Button text="FREE CONSULTATION" />
      </HeroLeft>
      <HeroRight>
        <HomeHeroImg src={HomeHeroImage} alt="IntelliCubix HomeHero Image" />
      </HeroRight>
    </Overlay>
  </MainContainer>; 
};

export default HomeHeroSection;